import { ParseError } from '@effect/schema/ParseResult';
import { Data, Request } from 'effect';
import { Particles } from '../schema';

export class GetParticlesError {
    readonly _tag = 'GetParticlesError';
    constructor(public originalError: unknown) {}
}

export class ParticlesParseError extends Data.TaggedError(
    '@fixtuur/backpack/ParticleService/ParticlesParseError',
)<{ originalError: ParseError }> {}

export interface GetParticles
    extends Request.Request<Particles, GetParticlesError | ParticlesParseError> {
    readonly _tag: 'GetParticles';
    tenant: string;
}

export const GetParticles = Request.tagged<GetParticles>('GetParticles');
